/** @prettier */

import type {CSSProperties, FC, ReactNode} from 'react';
import {useDrag} from 'react-dnd';
import {default as MuiBox} from '@mui/material/Box';

import {ItemTypes} from './ItemTypes';

const style: CSSProperties = {
  position: 'absolute',
  cursor: 'move',
};

export interface BoxProps {
  id: any;
  left: number;
  top: number;
  unitName: string;
  hideSourceOnDrag?: boolean;
  children?: ReactNode;
}

export const Box: FC<BoxProps> = ({
  id,
  left,
  top,
  unitName,
  hideSourceOnDrag,
  children,
}) => {
  //ドラッグ制御
  const [{isDragging}, drag] = useDrag(
    () => ({
      type: ItemTypes.BOX, //結びつけるドロップ制御のID
      item: {id, left, top, unitName}, //ドロップ制御に渡す項目
      collect: monitor => ({
        isDragging: monitor.isDragging(), //ドラッグしているかどうか
      }),
    }),
    [id, left, top, unitName] //依存関係
  );

  if (isDragging && hideSourceOnDrag) {
    return <MuiBox ref={drag} />;
  }
  return (
    <MuiBox
      className="box"
      ref={drag}
      style={{...style, left: Number(left), top: Number(top)}}
      data-testid="box">
      {children}
    </MuiBox>
  );
};
